var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M386.7,77.8h-190v318.6h190V77.8z M166.3,77.8h-41v318.6h41V77.8z M417,47.6v378.9H196.6v37.9h-30.3v-37.9 H95V47.6H417z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.7,77.8h-190v318.6h190V77.8z M166.3,77.8h-41v318.6h41V77.8z M417,47.6v378.9H196.6v37.9h-30.3v-37.9H95 V47.6H417z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournals);
export default __webpack_public_path__ + "static/media/journals.e242796368ce8855a4cc478fe8b8d48d.svg";
export { ForwardRef as ReactComponent };